import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {first} from "rxjs/operators";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {PerformanceService} from "../../../../performance/performance.service";

@Component({
    selector: 'db-optimization-success',
    templateUrl: './optimization-success.component.html',
    styleUrls: ['./optimization-success.component.scss'],
    standalone: false
})
export class OptimizationSuccessComponent implements OnInit {

  public websiteUrl: string;
  @Input() websiteId?: number;
  @Input() paidClient?: boolean;
  @Input() cannotClearCache?: boolean;
  @Input() userSubscription?: UserSubscription;
  @Output() readonly onResize: EventEmitter<[number, number]> = new EventEmitter<[number, number]>();
  @Output() readonly onBtnClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private _performanceService: PerformanceService,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this._resize();
    this._addEventHandlers();
  }

  private _resize(): void {
    this.onResize.emit([this.userSubscription && this.userSubscription.trialBoosterClient && !this.cannotClearCache ? 404 : 302, 700]);
  }

  private _addEventHandlers(): void {
    this._getWebsite();
  }

  public redirect(paidClient: boolean): void {
    if (this.websiteId) {
      this._router.navigate(['/websites/' + this.websiteId + '/booster/frontend'], {queryParams: {fromExploreDialog: 1, score: 1}});
    } else {
      this._router.navigate(['/websites/']);
    }
    this.sendEvent(paidClient);
    this.onBtnClick.emit(true);
  }

  public sendEvent(paidClient: boolean): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: paidClient ? 'Manage settings' : 'Optimize more pages',
      eventLabel: 'Speed Booster'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _getWebsite(): void {
    this._store.select(fromStore.getWebsite(this.websiteId))
      .pipe(
        first(website => !!website, null)
      )
      .subscribe(website => {
        this.websiteUrl = website && website.site_url.replace(/^https?:\/\//i, '');
      });
  }

}
